import React, { useEffect, useRef, useState } from 'react';

/**
 * PilaAvvisi — la pila in basso a destra dei pazienti in ritardo
 * (segreteria) e di quelli in sala d'attesa (medici).
 *
 * AL MASSIMO DUE RIQUADRI, poi «Leggi altri» (Alex, 24 settembre 2026).
 * La pila copriva i pulsanti della pagina: misurato sul banco a 1440 px,
 * un riquadro copriva un «apri visita» su tre, due li coprivano tutti, e
 * in una giornata con quattro ritardi la colonna arrivava al 70% dello
 * schermo. Il server beta lo ha trovato perche' i clic delle prove
 * finivano sopra la pila.
 *
 * I due che restano sono i primi dell'elenco, cioe' i piu' urgenti: il
 * ritardo piu' lungo, l'attesa piu' lunga. «Leggi altri» apre tutto,
 * «Mostra meno» richiude. Un solo posto per la regola, per le due pile.
 *
 * E LA PAGINA LE LASCIA POSTO IN FONDO (Alex, stesso giorno). Due
 * riquadri coprono ancora i pulsanti che capitano sotto (sulla scheda
 * paziente, tutti e tre gli «apri visita»): finche' la pila c'e', il
 * `body` ha in fondo uno spazio alto quanto lei (variabile
 * --rm-spazio-pila, Ritardi.css), cosi' scorrendo qualunque pulsante esce
 * da sotto. A scorrere e' la finestra, non .main-content: per questo lo
 * spazio sta sul body.
 */
const MASSIMO = 2;

const PilaAvvisi = ({ voci }) => {
    const [tutti, setTutti] = useState(false);
    const altri = voci.length - MASSIMO;
    const visibili = tutti || altri <= 0 ? voci : voci.slice(0, MASSIMO);
    const pila = useRef(null);
    useEffect(() => {
        const el = pila.current;
        if (!el || typeof ResizeObserver === 'undefined') return undefined;
        const radice = document.documentElement;
        /* 16 px del bordo in basso, piu' 16 di respiro. */
        const misura = () => radice.style.setProperty('--rm-spazio-pila', `${Math.ceil(el.getBoundingClientRect().height) + 32}px`);
        const o = new ResizeObserver(misura);
        o.observe(el);
        misura();
        return () => { o.disconnect(); radice.style.removeProperty('--rm-spazio-pila'); };
    }, []);
    return (
        <div className="rit-pila" role="status" aria-live="polite" ref={pila}>
            {visibili}
            {/* Ultimo nell'elenco = in cima alla pila (column-reverse): il
                tasto sta sopra i riquadri, non in mezzo. */}
            {altri > 0 && (
                <button type="button" className="rit-altri" onClick={() => setTutti((t) => !t)}>
                    {tutti ? 'Mostra meno' : `Leggi altri (${altri})`}
                </button>
            )}
        </div>
    );
};

export default PilaAvvisi;
